import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { db } from '../../services/firebase';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const SucursalesSettings = () => {
  const { isDemo } = useAuth();
  const [sucursales, setSucursales] = useState([]);
  const [form, setForm] = useState({ nombre: '', latitude: '', longitude: '', radius: '' });
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSucursales();
  }, [isDemo]);

  const loadSucursales = async () => {
    if (isDemo) {
      setSucursales([
        {
          id: 'demo-suc-1',
          nombre: 'Sucursal Hidalgo (Demo)',
          latitude: 25.6866,
          longitude: -100.3161,
          radius: 100
        }
      ]);
      return;
    }
    try {
      const snapshot = await getDocs(collection(db, 'sucursales'));
      const items = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setSucursales(items);
    } catch (error) {
      setMessage('Error al cargar sucursales');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isDemo) {
      setMessage('ℹ️ En modo demostración no se guardan cambios en las sucursales reales.');
      return;
    }
    setLoading(true);
    setMessage('');
    const data = {
      nombre: form.nombre,
      latitude: parseFloat(form.latitude),
      longitude: parseFloat(form.longitude),
      radius: parseFloat(form.radius)
    };

    try {
      if (editId) {
        await updateDoc(doc(db, 'sucursales', editId), data);
        setMessage('✅ Sucursal actualizada');
      } else {
        await addDoc(collection(db, 'sucursales'), data);
        setMessage('✅ Sucursal agregada');
      }
      setForm({ nombre: '', latitude: '', longitude: '', radius: '' });
      setEditId(null);
      loadSucursales();
    } catch (error) {
      setMessage(`❌ Error: ${error.message}`);
    }
    setLoading(false);
  };

  const handleEdit = (sucursal) => {
    if (isDemo) {
      setMessage('ℹ️ En modo demostración la edición está desactivada.');
      return;
    }
    setForm({
      nombre: sucursal.nombre,
      latitude: sucursal.latitude.toString(),
      longitude: sucursal.longitude.toString(),
      radius: sucursal.radius.toString()
    });
    setEditId(sucursal.id);
  };

  const handleDelete = async (id) => {
    if (isDemo) {
      setMessage('ℹ️ En modo demostración no se eliminan sucursales.');
      return;
    }
    if (window.confirm('¿Eliminar esta sucursal?')) {
      try {
        await deleteDoc(doc(db, 'sucursales', id));
        loadSucursales();
      } catch (error) {
        setMessage(`❌ Error al eliminar: ${error.message}`);
      }
    }
  };

  return (
    <div className="sucursales-settings">
      <h3>Gestión de Sucursales</h3>

      <form onSubmit={handleSubmit} className="form-section">
        <h4>{editId ? 'Editar Sucursal' : 'Agregar Sucursal'}</h4>
        <div className="field">
          <label>Nombre</label>
          <input
            type="text"
            value={form.nombre}
            onChange={(e) => setForm({...form, nombre: e.target.value})}
            required
            placeholder="Ej. Matriz, Sucursal Norte"
          />
        </div>
        <div className="field">
          <label>Latitud</label>
          <input
            type="number"
            step="any"
            value={form.latitude}
            onChange={(e) => setForm({...form, latitude: e.target.value})}
            required
          />
        </div>
        <div className="field">
          <label>Longitud</label>
          <input
            type="number"
            step="any"
            value={form.longitude}
            onChange={(e) => setForm({...form, longitude: e.target.value})}
            required
          />
        </div>
        <div className="field">
          <label>Radio (metros)</label>
          <input
            type="number"
            step="any"
            value={form.radius}
            onChange={(e) => setForm({...form, radius: e.target.value})}
            required
          />
        </div>
        <button type="submit" disabled={loading} className="btn btn-primary">
          {loading ? 'Guardando...' : editId ? 'Actualizar' : 'Agregar'}
        </button>
      </form>

      {message && <div className="message">{message}</div>}

      <div className="table-wrapper">
        <table className="erp-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Latitud</th>
              <th>Longitud</th>
              <th>Radio (m)</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sucursales.map((suc) => (
              <tr key={suc.id}>
                <td>{suc.nombre}</td>
                <td>{suc.latitude}</td>
                <td>{suc.longitude}</td>
                <td>{suc.radius}</td>
                <td>
                  <button className="btn btn-primary btn-sm" onClick={() => handleEdit(suc)}>
                    <i className="fa-solid fa-pen"></i>
                  </button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(suc.id)}>
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SucursalesSettings;